import { PublicPage, H2, P, UL } from "@/components/PublicPage";
import { BUSINESS, waLink } from "@/lib/site";

export default function Terms() {
  return (
    <PublicPage testid="terms-page" overline="Syarat & Ketentuan" title="Syarat & Ketentuan">
      <P>Dengan menggunakan Mas Tofa AI, Anda menyetujui syarat dan ketentuan berikut.</P>

      <H2>Akun</H2>
      <UL items={[
        "Anda bertanggung jawab menjaga kerahasiaan akun dan kata sandi Anda.",
        "Anda bertanggung jawab atas seluruh aktivitas pada akun Anda.",
      ]} />

      <H2>Konten yang Diunggah</H2>
      <UL items={[
        "Anda bertanggung jawab atas foto produk dan materi yang Anda unggah.",
        "Anda menyatakan memiliki hak untuk menggunakan konten yang diunggah.",
        "Dilarang mengunggah konten yang melanggar hukum atau hak pihak lain.",
      ]} />

      <H2>Konten Hasil AI</H2>
      <P>Video dan materi dihasilkan secara otomatis dengan bantuan AI. Hasil dapat bervariasi dan
        tidak dijamin sempurna atau sesuai dengan ekspektasi tertentu.</P>

      <H2>Kredit & Pembuatan Video</H2>
      <UL items={[
        "Kredit adalah satuan yang digunakan untuk pembuatan video.",
        "Saat ini, 1 pembuatan video menggunakan 6 kredit aplikasi.",
        "Kredit yang digunakan untuk proses yang telah berjalan mengikuti mekanisme reservasi dan penyelesaian kredit pada sistem.",
      ]} />

      <H2>Pembayaran</H2>
      <P>Pembelian kredit dilakukan melalui metode pembayaran yang tersedia. Untuk transfer manual,
        kredit ditambahkan setelah pembayaran diverifikasi oleh Admin.</P>

      <H2>Ketergantungan Penyedia & Gangguan Layanan</H2>
      <P>Layanan bergantung pada penyedia pihak ketiga (mis. penyedia AI dan penyimpanan). Layanan
        dapat mengalami gangguan atau pemeliharaan sewaktu-waktu.</P>

      <H2>Kegagalan Pembuatan Video</H2>
      <P>Jika pembuatan video gagal karena kendala sistem/penyedia, mekanisme kredit pada sistem
        akan menyesuaikan sesuai hasil proses. Untuk kasus tertentu, Anda dapat menghubungi Admin.</P>

      <H2>Penggunaan yang Dilarang</H2>
      <UL items={[
        "Penyalahgunaan layanan, upaya meretas, atau mengganggu sistem.",
        "Penggunaan untuk konten ilegal atau melanggar hak pihak lain.",
      ]} />

      <H2>Penangguhan & Penghentian</H2>
      <P>Kami dapat menangguhkan atau menghentikan akun yang melanggar ketentuan ini.</P>

      <H2>Batasan Tanggung Jawab</H2>
      <P>Layanan disediakan "sebagaimana adanya". Dalam batas yang diizinkan hukum, kami tidak
        bertanggung jawab atas kerugian tidak langsung yang timbul dari penggunaan layanan.</P>

      <H2>Dukungan</H2>
      <P>Untuk bantuan, hubungi WhatsApp Admin{" "}
        <a className="text-blue-600 hover:underline" href={waLink()} target="_blank" rel="noopener noreferrer">{BUSINESS.whatsappDisplay}</a>.</P>

      <H2>Perubahan</H2>
      <P>Ketentuan ini dapat diperbarui sewaktu-waktu dan akan ditampilkan pada halaman ini.</P>
    </PublicPage>
  );
}
